// Workspace constants extracted from STAADWorkspace3D

export const DEFAULT_PLANE_INFO = {
  currentPlane: 'XY',
  viewOrientation: 'Front',
  coordinateSystem: 'Global',
  elevation: 0
};

export const DEFAULT_QUICK_NODE_COORDS = {
  x: 0,
  y: 0,
  z: 0
};

export const DEFAULT_COORDINATE_INPUT_VALUES = {
  x: '',
  y: '',
  z: ''
};

export const DEFAULT_TOOLTIP_POSITION = {
  x: 0,
  y: 0
};

// Camera configuration constants
// Z-UP CONVENTION: Engineering standard for structural analysis
// X-axis: Horizontal (East-West), Y-axis: Horizontal (North-South), Z-axis: Vertical (Elevation)
export const CAMERA_CONFIG = {
  DEFAULT_POSITION: [0, -60, 0] as [number, number, number], // Front view: looking along +Y axis from south
  FOV: 50, // Increased from 45 for wider view (better for large structures)
  NEAR: 0.01, // Reduced from 0.1 for closer inspection
  FAR: 500000, // Massively increased for very large structures (10x increase)
  UP: [0, 0, 1] as [number, number, number] // Z-UP: Vertical axis (engineering standard)
};

// Grid configuration constants
export const GRID_CONFIG = {
  SIZE: 10000, // Expanded for infinite space
  DIVISIONS: 1000 // More divisions for better granularity
};

// Lighting configuration constants
export const LIGHTING_CONFIG = {
  AMBIENT_INTENSITY: 0.6,
  DIRECTIONAL_INTENSITY: 0.6,
  DIRECTIONAL_SECONDARY_INTENSITY: 0.4,
  DIRECTIONAL_POSITION_1: [5, -5, 5] as [number, number, number],  // Z-UP adjusted
  DIRECTIONAL_POSITION_2: [-5, 5, 5] as [number, number, number]   // Z-UP adjusted
};

// Orbit controls configuration
export const ORBIT_CONTROLS_CONFIG = {
  MIN_DISTANCE: 1,
  MAX_DISTANCE: 10000, // Increased for larger coordinate space
  ENABLE_DAMPING: true,
  DAMPING_FACTOR: 0.05,
  MAX_POLAR_ANGLE: Math.PI / 2,
  TARGET: [0, 0, 0] as [number, number, number],
  PAN_SPEED: 5, // Increased pan speed for better navigation
  ENABLE_PAN: true,
  SCREEN_SPACE_PANNING: true,
  ZOOM_SPEED: 1.2 // Increased zoom speed
};

// View configurations for camera positioning
// Z-UP CONVENTION: Z-axis is vertical (elevation)
// IMPROVED: Better camera positions for distinct views
export const VIEW_CONFIGURATIONS = {
  front: {  // FRONT ELEVATION (XZ Plane): looking along +Y axis from SOUTH - shows WIDTH × HEIGHT
    position: [0, -80, 0] as [number, number, number],  // Far south, at ground level
    target: [0, 0, 0] as [number, number, number],
    label: 'FRONT (XZ)'
  },
  top: {  // PLAN VIEW (XY Plane): looking down -Z axis from ABOVE - shows WIDTH × DEPTH  
    position: [0, 0, 80] as [number, number, number],  // Directly above, higher position
    target: [0, 0, 0] as [number, number, number],
    label: 'PLAN (XY)'
  },
  side: {  // RIGHT ELEVATION (YZ Plane): looking along -X axis from EAST - shows DEPTH × HEIGHT
    position: [80, 0, 0] as [number, number, number],  // Far east, at ground level
    target: [0, 0, 0] as [number, number, number],
    label: 'RIGHT (YZ)'
  },
  isometric: {  // 3D VIEW: perspective from corner
    position: [50, -50, 50] as [number, number, number],  // SE corner, elevated
    target: [0, 0, 0] as [number, number, number],
    label: '3D VIEW'
  }
};

// Animation configuration
export const ANIMATION_CONFIG = {
  CAMERA_TRANSITION_DURATION: 1000,
  NODE_ANIMATION_DURATION: 500,
  EASING: 'ease-in-out'
};

// Tolerances and thresholds
export const TOLERANCES = {
  LINE_INTERSECTION: 0.01,
  BEAM_CLICK: 0.5,
  NODE_SNAP: 1.0,
  DRAG_THRESHOLD: 5
};

// UI styling constants
export const UI_STYLES = {
  PANEL_MIN_SIZE: 15,
  PANEL_DEFAULT_SIZES: {
    LEFT: 20,
    CENTER: 60,
    RIGHT: 20
  },
  OVERLAY_Z_INDEX: 40,
  TOOLTIP_Z_INDEX: 50
};

// Keyboard shortcuts
export const KEYBOARD_SHORTCUTS = {
  TOGGLE_LABELS: 'l',
  TOGGLE_GRID: 'g',
  NODE_MODE: 'n',
  BEAM_MODE: 'b',
  PERP_MODE: 'p',
  // SELECT_MODE: 's' removed - selection mode is now activated via double-click only
  TOGGLE_TABLES: 't',
  COPY: 'ctrl+c',
  PASTE: 'ctrl+v',
  ESCAPE: 'escape'
};
